module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/cocktail.svg?b42d9fcda091fb17e19e28e1b4ec3046";